/**
 * Códigos de erro da leitura da planilha de itens de compra (Fase 26).
 *
 * Como na Fase 25, são erros **do arquivo inteiro** — o cabeçalho que não existe, a aba
 * sem nenhuma linha. O que está errado em uma linha só não derruba a leitura: vira `issue`,
 * com o número da linha do Excel, e a conferência mostra ao lado das linhas boas.
 */
export const PURCHASE_TEMPLATE_ERROR = {
  /** Nenhuma linha da aba "Itens de compra" traz as colunas que identificam a linha de compra. */
  LINES_HEADER_NOT_FOUND: 'PURCHASE_LINES.LINES_HEADER_NOT_FOUND',
  /** A aba "Itens de compra" tem o cabeçalho, mas nenhuma linha de dados abaixo dele. */
  LINES_NO_ROWS: 'PURCHASE_LINES.LINES_NO_ROWS',
  /** Nenhuma linha da aba "Mão de obra" traz as colunas do HH por função. */
  LABOR_HEADER_NOT_FOUND: 'PURCHASE_LINES.LABOR_HEADER_NOT_FOUND',
  /** A aba "Mão de obra" tem o cabeçalho, mas nenhuma linha de dados abaixo dele. */
  LABOR_NO_ROWS: 'PURCHASE_LINES.LABOR_NO_ROWS',
} as const;
